export const GoogleMapApiConfig = 'AIzaSyCkbgvxzRDR4M9hRYwc_6n0Yr1_gCMuRUs';